import { lineHealth, statusStats, tickerNotes } from '@/mocks/homeData';

export default function StatusSection() {
  const tickerItems = [...tickerNotes, ...tickerNotes];

  return (
    <section id="status" className="scroll-mt-24 w-full bg-background-100 border-y border-background-200 py-14 md:py-20">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-label tracking-[0.16em] text-secondary-700 uppercase">
              <i className="ri-radar-line" aria-hidden="true" />
              Live Status
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              实时状态栏：能不能进，一眼就知道
            </h2>
            <p className="mt-3 text-sm md:text-base leading-relaxed text-foreground-700">
              我们按固定节奏巡检每一条地址，把校验次数、响应延迟和线路负载都摊开给你看。访问不顺畅时，先看这里，比反复试更省事。
            </p>
          </div>
          <div className="shrink-0 inline-flex items-center gap-2.5 px-4 py-3 rounded-lg bg-accent-500 text-background-50">
            <i className="ri-checkbox-circle-line text-xl" aria-hidden="true" />
            <span className="text-sm font-label whitespace-nowrap">当前全部线路通畅</span>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {statusStats.map((item) => (
            <div key={item.id} className="rounded-lg bg-background-50 border border-background-200 p-5">
              <p className="font-heading text-3xl font-bold text-foreground-950">
                {item.value}
                <span className="ml-1 text-sm font-label font-normal text-foreground-500">{item.unit}</span>
              </p>
              <p className="mt-2 text-sm font-label text-foreground-800">{item.label}</p>
              <p className="mt-1 text-xs font-label text-foreground-500">{item.hint}</p>
            </div>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-5">
          <div className="lg:col-span-8 rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
            <h3 className="font-heading text-lg font-bold text-foreground-950">线路负载明细</h3>
            <ul className="mt-5 space-y-4">
              {lineHealth.map((line) => (
                <li key={line.id}>
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <div className="flex items-center gap-2.5">
                      <span className="w-1.5 h-1.5 rounded-full bg-accent-500" aria-hidden="true" />
                      <span className="text-sm font-label text-foreground-900">{line.name}</span>
                      <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-[11px] font-label whitespace-nowrap">
                        {line.node}
                      </span>
                    </div>
                    <div className="flex items-center gap-4 text-xs font-label text-foreground-600">
                      <span className="inline-flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-timer-line" aria-hidden="true" />
                        {line.latency}
                      </span>
                      <span className="text-accent-700 whitespace-nowrap">{line.state}</span>
                    </div>
                  </div>
                  <div className="mt-2 flex items-center gap-3">
                    <div className="flex-1 h-1.5 rounded-full bg-background-200 overflow-hidden">
                      <div
                        className="h-full rounded-full bg-secondary-500 origin-left animate-grow-x"
                        style={{ width: `${line.load}%` }}
                      />
                    </div>
                    <span className="w-14 text-right text-[11px] font-label text-foreground-500">负载 {line.load}%</span>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4 rounded-lg bg-secondary-100 border border-secondary-200 p-5 md:p-6 flex flex-col">
            <h3 className="font-heading text-lg font-bold text-secondary-950">最近更新日志</h3>
            <ul className="mt-5 space-y-4 flex-1">
              {tickerNotes.slice(0, 4).map((note) => (
                <li key={note} className="flex gap-3">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-secondary-500 shrink-0" aria-hidden="true" />
                  <p className="text-[13px] leading-relaxed text-secondary-900">{note}</p>
                </li>
              ))}
            </ul>
            <p className="mt-5 pt-4 border-t border-secondary-300 text-[11px] font-label text-secondary-700">
              日志每轮校验后自动追加
            </p>
          </div>
        </div>
      </div>

      <div className="mt-10 ticker-mask overflow-hidden border-t border-background-200 pt-4">
        <div className="flex w-max animate-ticker gap-10 px-4 md:px-10">
          {tickerItems.map((note, index) => (
            <span
              key={`${note}-${index}`}
              className="flex items-center gap-2.5 text-xs font-label text-foreground-600 whitespace-nowrap"
            >
              <i className="ri-arrow-right-up-line text-accent-600" aria-hidden="true" />
              {note}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}